import { IVideosBlock, IVisualBlock, TCmsBlocks, IFeaturesBlock, IDesignersBlock, IProductGalleryBlock, IDescriptionWithSlidesBlock, IVisualWithButtonBlock, IProductPremiumBlock, IPageHeaderBlock, ILiveChatBlock, IPageSimpleHeader, IPageSmallHeader, IPageBigHeader, IMosaicBlock, TFullImageWithHeading, TSmallHeaderWithText, ISpacingBlock, ICatalogSectionBlock, IInspirationProductGallerySingle, IInspirationProductGalleryDuo, IInspirationProductsSlider, IInspirationProductGalleryMulti, IInspirationHeaderBlock, IWysiwygBlock, IServices, IHeaderObject, IVoxboxObject, ISocialMedia, IVoxboxInfoBlock, IListingInspirationsBlock, ITableBlock, IBlockAdditionalData, ICategoryTilesBlock, ICategoryHeaderBlock, ICategorySliderWithNavBlock, ICategoryGalleryBlock, ICategoryLogoCarousel, ICategoryCollectionCarouselBlock, ICategoryUSPBlock, IMultiIconBlock, IMainHeaderBlock, IHomeCategoryTilesBlock, IOfferCardsBlock, IProductsCarouselBlock, IFullscreenMediaBlock, IPromoBannerBlock, IImageGalleryBlock, ISloganHomeBlock, ITitleBlock } from '@features/cms/typescript';
import VisualBlock from '@features/cms/components/collections/VisualBlock/VisualBlock';
import VideosBlock from '@features/cms/components/collections/VideosBlock/VideosBlock';
import FeaturesBlock from '@features/cms/components/collections/FeaturesBlock/FeaturesBlock';
import DesignersBlock from '@features/cms/components/collections/DesignersBlock/DesignersBlock';
import ProductPremiumBlock from '@features/cms/components/collections/ProductPremiumBlock/ProductPremiumBlock';
import WysiwygBlock from '@features/cms/components/pages/WysiwygBlock/WysiwygBlock';
import { IParsedImage } from '@components/typescript';
import ProductGalleryBlock from '@features/cms/components/collections/ProductGalleryBlock/ProductGalleryBlock';
import DescriptionWithSlidesBlock from '@features/cms/components/collections/DescriptionWithSlidesBlock/DescriptionWithSlidesBlock';
import VisualWithButtonBlock from '@features/cms/components/collections/VisualWithButtonBlock/VisualWithButtonBlock';
import CatalogSectionBlocks from '@features/cms/components/pages/CatalogSectionBlocks/CatalogSectionBlocks';
import PageHeaderBlock from '@features/cms/components/pages/PageHeaderBlock/PageHeaderBlock';
import LiveChatBlock from '@features/cms/components/pages/LiveChatBlock/LiveChatBlock';
import InspirationHeaderBlock from '@features/cms/components/inspirations/InspirationHeaderBlock/InspirationHeaderBlock';
import PagesAccordion from '@features/pages/components/PagesAccordion/PagesAccordion';
import { IAccordion, ICategoryDescriptionWithImage, ICategoryLabelBlock, IFrameAccordion, IImageAccordion } from '@features/pages/typescript';
import SpacingBlock from '@features/cms/components/collections/SpacingBlock/SpacingBlock';
import MosaicBlock from '@features/cms/components/pages/MosaicBlock/MosaicBlock';
import FullImageWithHeading from '@features/cms/components/pages/FullImageWithHeading/FullImageWithHeading';
import SmallHeaderWithText from '@features/cms/components/pages/SmallHeaderWithText/SmallHeaderWithText';
import InspirationProductGallerySingle from '@features/cms/components/inspirations/InspirationProductGallerySingle/InspirationProductGallerySingle';
import InspirationProductGalleryDuo from '@features/cms/components/inspirations/InspirationProductGalleryDuo/InspirationProductGalleryDuo';
import InspirationProductsSlider from '@features/cms/components//inspirations/InspirationProductsSlider/InspirationProductsSlider';
import InspirationProductGalleryMulti from '@features/cms/components/inspirations/InspirationProductGalleryMulti/InspirationProductGalleryMulti';
import ServicesSection from '@features/homepage/sections/Services/ServicesSection';
import FrameAccordion from '@features/pages/components/PagesAccordion/components/FrameAccordion';
import HeaderSection from '@features/homepage/sections/Header/HeaderSection';
import MainCategoriesSection from '@features/homepage/sections/MainCategories/MainCategoriesSection';
import BrandSection from '@features/homepage/sections/Brand/BrandSection';
import { IBrandObject } from '@features/homepage/typescript';
import VoxboxSection from '@features/homepage/sections/Voxbox/VoxboxSection';
import SocialMediaSection from '@features/homepage/sections/SocialMedia/SocialMediaSection';
import ImageAccordion from '@features/pages/components/PagesAccordion/components/ImageAccordion';
import InspirationVoxboxBlock from '@features/cms/components/inspirations/InspirationVoxboxBlock/InspirationVoxboxBlock';
import InspirationArticlesBlock from '@features/cms/components/inspirations/InspirationArticlesBlock/InspirationArticlesBlock';
import TableBlock from '@features/cms/components/pages/TableBlock/TableBlock';
import ShowroomAdvantages from '@features/cms/components/pages/ShowroomAdvantages/ShowroomAdvantages';
import CategoryTilesBlock from '@features/cms/components/categories/CategoryTilesBlock/CategoryTilesBlock';
import CategoryHeaderBlock from '@features/cms/components/categories/CategoryHeaderBlock/CategoryHeaderBlock';
import CategorySliderWithNavBlock from '@features/cms/components/categories/CategorySliderWithNavBlock/CategorySliderWithNavBlock';
import CategoryCollectionCarouselBlock from '@features/cms/components/categories/CategoryCollectionCarouselBlock/CategoryCollectionCarouselBlock';
import CategoryGalleryBlock from '@features/cms/components/categories/CategoryGalleryBlock/CategoryGalleryBlock';
import CategoryLogoCarouselWithTitle from '@features/cms/components/categories/CategoryLogoCarouselWithTitle/CategoryLogoCarouselWithTitle';
import CategoryUSPBlock from '@features/cms/components/categories/CategoryUSPBlock/CategoryUSPBlock';
import validateBlock from '@utils/validate/validateBlock';
import CategoryLabelBlock from '@features/cms/components//categories/CategoryLabelBlock/CategoryLabelBlock';
import theme from '@styles/theme';
import DescriptionWithImageAccordion from '@features/pages/components/PagesAccordion/components/DescriptionWithImageAccordion';
import MultiIconBlock from '@features/cms/components/pages/MultiIconBlock/MultiIconBlock';
import { MainHeader } from '@components/MainHeader';
import { CategoryTilesBlock as HomeCategoryTilesBlock } from '@components/CategoryTilesBlock';
import { OfferCardsBlock } from '@components/OfferCardsBlock';
import { ProductsCarouselBlock } from '@components/ProductsCarouselBlock';
import { FullscreenMediaBlock } from '@components/FullscreenMediaBlock';
import { PromoBannerBlock } from '@components/PromoBannerBlock';
import { ImageGalleryBlock } from '@components/ImageGalleryBlock';
import SloganHomeBlock from '@components/CategoryTilesBlock/SloganHomeBlock';
import { TitleBlock } from '@components/TitleBlock';
import NewSpacingBlock from '@features/cms/components/collections/NewSpacingBlock/NewSpacingBlock';
import { INewSpacingBlock } from '@features/cms/services/page/NewSpacingBlock';
type PropsType = {
  block: TCmsBlocks;
  isFirst?: boolean;
  defaultBackground?: string;
};
const RenderCmsBlock = ({
  block,
  isFirst = false,
  defaultBackground = theme.rawColors.neutralWhite
}: PropsType) => {
  const validationResult = validateBlock(block);
  if (validationResult?.error) return null;
  const renderBlock = () => {
    switch (block?.type) {
      case 'visualBlock':
        return <VisualBlock data={block as IVisualBlock} isFirst={isFirst} />;
      case 'videosBlock':
        return <VideosBlock data={block as IVideosBlock} isFirst={isFirst} />;
      case 'designersBlock':
        return <DesignersBlock data={block as IDesignersBlock} isFirst={isFirst} />;
      case 'visualWithButtonBlock':
        return <VisualWithButtonBlock data={block as IVisualWithButtonBlock} isFirst={isFirst} />;
      case 'featuresBlock':
        return <FeaturesBlock data={block as IFeaturesBlock<IParsedImage>} isFirst={isFirst} />;
      case 'spacingBlock':
        return <SpacingBlock data={block as ISpacingBlock} />;
      case 'productPremiumBlock':
        return <ProductPremiumBlock data={block as IProductPremiumBlock<IParsedImage>} isFirst={isFirst} />;
      case 'wysiwyg':
        return <WysiwygBlock data={block as IWysiwygBlock} defaultBackground={defaultBackground} />;
      case 'productGalleryBlock':
        return <ProductGalleryBlock data={block as IProductGalleryBlock<IParsedImage>} isFirst={isFirst} />;
      case 'descriptionWithSlidesBlock':
        return <DescriptionWithSlidesBlock data={block as IDescriptionWithSlidesBlock} isFirst={isFirst} defaultBackground={defaultBackground} />;
      case 'pageHeaderBlock':
        return <PageHeaderBlock data={block as IPageHeaderBlock<IPageSimpleHeader | IPageSmallHeader | IPageBigHeader>} isFirst={isFirst} defaultBackground={defaultBackground} />;
      case 'mosaicBlock':
        return <MosaicBlock data={block as IMosaicBlock} isFirst={isFirst} defaultBackground={defaultBackground} />;
      case 'fullImageWithHeading':
        return <FullImageWithHeading data={block as TFullImageWithHeading} isFirst={isFirst} />;
      case 'smallHeaderWithText':
        return <SmallHeaderWithText data={block as TSmallHeaderWithText} defaultBackground={defaultBackground} isFirst={isFirst} />;
      case 'liveChatBlock':
        return <LiveChatBlock data={block as ILiveChatBlock} />;
      case 'accordion':
        return <PagesAccordion key={Math.random()} block={block as IAccordion} defaultBackground={defaultBackground} isFirst={isFirst} />;
      case 'catalogSectionBlock':
        return <CatalogSectionBlocks data={block as ICatalogSectionBlock} defaultBackground={defaultBackground} isFirst={isFirst} />;
      case 'inspirationProductGallerySingle':
        return <InspirationProductGallerySingle defaultBackground={defaultBackground} data={block as IInspirationProductGallerySingle} />;
      case 'inspirationProductGalleryDuo':
        return <InspirationProductGalleryDuo defaultBackground={defaultBackground} data={block as IInspirationProductGalleryDuo} />;
      case 'inspirationProductGalleryTrio':
        return <InspirationProductGalleryMulti defaultBackground={defaultBackground} data={block as IInspirationProductGalleryMulti} />;
      case 'inspirationProductGalleryQuartet':
        return <InspirationProductGalleryMulti defaultBackground={defaultBackground} data={block as IInspirationProductGalleryMulti} />;
      case 'inspirationProductsSlider':
        return <InspirationProductsSlider defaultBackground={defaultBackground} data={block as IInspirationProductsSlider} />;
      case 'inspirationHeaderBlock':
        return <InspirationHeaderBlock defaultBackground={defaultBackground} data={block as IInspirationHeaderBlock} isFirst={isFirst} />;
      case 'categoryHeader':
        return <CategoryHeaderBlock defaultBackground={defaultBackground} data={block as ICategoryHeaderBlock} isFirst={isFirst} />;
      case 'categorySliderWithNav':
        return <CategorySliderWithNavBlock defaultBackground={defaultBackground} data={block as ICategorySliderWithNavBlock} isFirst={isFirst} />;
      case 'categoryCollectionCarousel':
        return <CategoryCollectionCarouselBlock defaultBackground={defaultBackground} data={block as ICategoryCollectionCarouselBlock} isFirst={isFirst} />;
      case 'categoryGallery':
        return <CategoryGalleryBlock defaultBackground={defaultBackground} data={block as ICategoryGalleryBlock} isFirst={isFirst} />;
      case 'services':
        return <ServicesSection services={block as IServices} isFirst={isFirst} />;
      case 'frame':
        return <FrameAccordion defaultBackground={defaultBackground} frame={block as IFrameAccordion} withContainerMargin />;
      case 'header':
        return <HeaderSection header={block as IHeaderObject} isFirst={isFirst} />;
      case 'slidesWithDescriptionBlock':
        return <MainCategoriesSection defaultBackground={defaultBackground} mainCategories={block as IDescriptionWithSlidesBlock} isFirst={isFirst} />;
      case 'slidesWithText':
        return <BrandSection brand={block as IBrandObject} isFirst={isFirst} />;
      case 'video':
        return <VoxboxSection voxbox={block as IVoxboxObject} isFirst={isFirst} />;
      case 'socialMedia':
        return <SocialMediaSection socialMedia={block as ISocialMedia} isFirst={isFirst} />;
      case 'image':
        return <ImageAccordion imageAccordion={block as IImageAccordion} withMargin />;
      case 'voxboxInfoBlock':
        return <InspirationVoxboxBlock block={block as IVoxboxInfoBlock} isFirst={isFirst} />;
      case 'listingProjectBlock':
        return <InspirationArticlesBlock articles={[]} numberOfIdeas={8} block={block as IListingInspirationsBlock} isInterior seeMoreButton defaultBackground={defaultBackground} />;
      case 'listingIdeaBlock':
        return <InspirationArticlesBlock articles={[]} numberOfIdeas={8} block={block as IListingInspirationsBlock} isInterior={false} seeMoreButton defaultBackground={defaultBackground} />;
      case 'labelBlock':
        return <CategoryLabelBlock data={block as ICategoryLabelBlock} isFirst={isFirst} />;
      case 'table':
        return <TableBlock defaultBackground={defaultBackground} data={block as ITableBlock} />;
      case 'showroomAdvantages':
        return <ShowroomAdvantages data={block as IBlockAdditionalData} />;
      case 'categoryTiles':
        return <CategoryTilesBlock defaultBackground={defaultBackground} data={block as ICategoryTilesBlock} />;
      case 'categoryLogoCarousel':
        return <CategoryLogoCarouselWithTitle defaultBackground={defaultBackground} data={block as ICategoryLogoCarousel} />;
      case 'categoryUSPBlock':
        return <CategoryUSPBlock data={block as ICategoryUSPBlock} />;
      case 'descriptionWidthImage':
        return <DescriptionWithImageAccordion descriptionWithImageAccordion={block as ICategoryDescriptionWithImage} />;
      case 'multiIcon':
        return <MultiIconBlock data={block as IMultiIconBlock} />;
      case 'mainHeader':
        return <MainHeader data={block as IMainHeaderBlock} />;
      case 'offerBlock':
        return <HomeCategoryTilesBlock data={block as IHomeCategoryTilesBlock} />;
      case 'newsBlock':
      case 'offerCardsBlock':
        return <OfferCardsBlock data={block as IOfferCardsBlock} />;
      case 'productsCarouselBlock':
        return <ProductsCarouselBlock data={block as IProductsCarouselBlock} />;
      case 'fullscreenMediaBlock':
        return <FullscreenMediaBlock data={block as IFullscreenMediaBlock} />;
      case 'promoBannerBlock':
        return <PromoBannerBlock data={block as IPromoBannerBlock} />;
      case 'imageGalleryBlock':
        return <ImageGalleryBlock data={block as IImageGalleryBlock} />;
      case 'sloganHomeBlock':
        return <SloganHomeBlock data={block as ISloganHomeBlock} />;
      case 'spacingNewBlock':
        return <NewSpacingBlock data={block as INewSpacingBlock} />;
      case 'ideasBlock':
        return <OfferCardsBlock data={block as IOfferCardsBlock} />;
      case 'storiesBlock':
        return <OfferCardsBlock data={block as IOfferCardsBlock} />;
      case 'yourInteriorsBlock':
        return <ImageGalleryBlock data={block as IImageGalleryBlock} />;
      case 'titleBlock':
        return <TitleBlock data={block as ITitleBlock} />;
      default:
        return null;
    }
  };
  const content = renderBlock();
  if (!content) return null;
  return <div id={block?.code || undefined}>{content}</div>;
};
export default RenderCmsBlock;